import * as React from "react";
import Input from "@Tmp/Fields/Input";
import Country from "@Tmp/Fields/Country";
import { AddressProps } from "./Address.types";

const Address: React.FC<AddressProps> = ({
    address,
    address1,
    city,
    zipcode,
    country,
    ...props
}) => {
    return (
        <>
            <Input
                {...address}
                iconBefore="fas fa-home"
                input={{
                    maxLength: 30,
                    ...address?.input,
                }}
                classes={{
                    wrapper: address1 ? "tmp-input-8" : "",
                    ...address?.classes,
                }}
            />
            {address1 && (
                <Input
                    {...address1}
                    input={{
                        maxLength: 30,
                        ...address1?.input,
                    }}
                    classes={{
                        wrapper: "tmp-input-4",
                        ...address1?.classes,
                    }}
                />
            )}
            <Input
                {...zipcode}
                input={{
                    maxLength: 10,
                    ...zipcode?.input,
                }}
                classes={{
                    wrapper: "tmp-input-3",
                    ...zipcode?.classes,
                }}
            />
            <Input
                {...city}
                input={{
                    maxLength: 30,
                    ...city?.input,
                }}
                classes={{
                    wrapper: "tmp-input-5",
                    ...city?.classes,
                }}
            />
            <Country
                {...country}
                classes={{
                    wrapper: "tmp-input-4",
                    ...country?.classes,
                }}
            />
        </>
    );
};

export default Address;
